import React from "react";
import { useNavigate } from "react-router-dom";
import { daysLeftShort } from "../../utils/lastMinute";

// Entry point (design 6a / mobile 8j): "List as available" on a My-Players
// card/row. Prefills the shared Last Minute composer with this player
// (Invariant 13 — same composer as the page-level "List a player"). When the
// player is ALREADY listed (an active listing exists — resolved by the caller
// from the owner Mine serializer's player_id), the button is replaced by the
// green "On Last Minute · Nd left" pill + a "View listing" action (6a draws a
// bordered button; the 8j mobile row uses the compact text link).
const ListAsAvailableButton = ({ playerId, listing = null, className = "", compact = false }) => {
  const navigate = useNavigate();
  const size = compact ? "px-3 py-1.5 text-[12px]" : "px-3.5 py-2 text-[12.5px]";

  if (listing) {
    const left = daysLeftShort(listing.expires_at);
    return (
      <div className={`inline-flex items-center gap-2 ${className}`} onClick={(e) => e.stopPropagation()}>
        <span
          className={`inline-flex items-center gap-1.5 rounded-full bg-[#E6F6EC] text-[#0E7C3C] font-semibold ${
            compact ? "px-2.5 py-1.5 text-[11.5px]" : "px-3 py-1.5 text-[12px]"
          }`}
        >
          <span className="w-[5px] h-[5px] rounded-full bg-[#22A75D]" />
          On Last Minute{left ? ` · ${left}` : ""}
        </span>
        {compact ? (
          <button
            type="button"
            onClick={() => navigate("/last-minute/my-listings")}
            className="text-[12px] font-semibold text-[#1466D8] hover:underline whitespace-nowrap"
          >
            View listing
          </button>
        ) : (
          <button
            type="button"
            onClick={() => navigate("/last-minute/my-listings")}
            className="rounded-[10px] border border-[#D8E0EA] bg-white px-3.5 py-2 text-[12.5px] font-semibold text-[#33475E] hover:bg-gray-50 whitespace-nowrap"
          >
            View listing
          </button>
        )}
      </div>
    );
  }

  const go = (e) => {
    e.stopPropagation();
    navigate(`/last-minute?compose=player&playerId=${encodeURIComponent(playerId)}`);
  };
  return (
    <button
      type="button"
      onClick={go}
      className={`inline-flex items-center justify-center rounded-[10px] border border-[#BDD9FF] bg-[#E9F2FF] text-[#1466D8] font-semibold hover:bg-[#DCEBFF] ${size} ${className}`}
    >
      List as available
    </button>
  );
};

export default ListAsAvailableButton;
